import React, { useEffect } from "react";
import styled from "styled-components";

import PageWrapper from "../components/PageWrapper";
import Seo from "../components/Seo";
import ProjectHero from "../sections/openings/ProjectHero";
import ProjectFacts from "../sections/openings/ProjectFacts";
import LinkedInCta from "../sections/openings/LinkedInCta";
import ApplicationForm from "../sections/openings/ApplicationForm";
import { trackEvent } from "../lib/openings";

const Layout = styled.div`
  background: var(--nd-black);
`;

const OpeningDetailPage = ({ pageContext }) => {
  const { opening } = pageContext;

  useEffect(() => {
    trackEvent("opening_view", { opening_id: opening.id, opening_slug: opening.slug });
  }, [opening.id, opening.slug]);

  const seoDescription =
    `${opening.title} for ${opening.clientHint}. ${opening.durationMonths}-month engagement, ${opening.location}. Apply on this page or via LinkedIn.`;

  return (
    <>
      <Seo
        title={`${opening.title} — Open position`}
        description={seoDescription}
        pathname={`/team/openings/${opening.slug}/`}
      />
      <PageWrapper>
        <Layout>
          <ProjectHero opening={opening} />
          <ProjectFacts opening={opening} />
          <LinkedInCta opening={opening} />
          <ApplicationForm opening={opening} />
        </Layout>
      </PageWrapper>
    </>
  );
};

export default OpeningDetailPage;
